import { Injectable } from '@angular/core';

import { CRUDGenericService } from 'attcei-bo-fw';
import { Observable, Subscriber } from 'rxjs';
import { RouteLocationDTO } from './dto/RouteLocationDTO';
import { PaginatedDTO } from './dto/PaginatedDTO';


class InternalState {
    constructor(
        public nItemsSent: number
    ) {}

}

@Injectable({
    providedIn: 'root'
  })
export class LocationsService {

    constructor(private service: CRUDGenericService) { }

    get() {
        return new Observable<RouteLocationDTO>(observer => {
            this.load(1, observer, true, new InternalState(0));
        });
    }

    load(page: number, observer: Subscriber<RouteLocationDTO>, loadNexts: boolean, state: InternalState) {
        const nItemsPerPage = 500;
        this.service.getDataItem('builder/routes/location?pageNumber=' + page + '&pageLenght=' + nItemsPerPage, true)
                .subscribe((data: PaginatedDTO<RouteLocationDTO>) => {
                    const nPages = Math.ceil(data.total / nItemsPerPage);
                    if (nPages > 1 && loadNexts) {
                        for (let i = 1; i < nPages; i++) {
                            this.load(i + 1, observer, false, state);
                        }
                    }
                    for (const entry of data.contents ) {
                        state.nItemsSent++;
                        observer.next(entry);
                    }
                    if (state.nItemsSent >= data.total) {
                        console.log('All data was loaded: ' + state.nItemsSent + '/' + data.total);
                        observer.complete();
                    }
                });

    }
}
